import { CloseOutlined, FilterOutlined, PlusOutlined } from "@ant-design/icons";
import { Col, Divider, Flex, Modal, Row, Slider, Space, Tag, Button, Card } from "antd";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { CardContainer } from "components/elements";
import { Input, Select, Switch } from "components/form";
import WorkingLocationTable from "components/table/WorkingLocationTable";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";


import schema, {
  DEVICE_TYPE,
  initialValues as INITIAL_VALUES,
} from "../schemas/workingLocationSchema";
import styles from "../styles/Attendance.module.css";
import AttendenceFilter from "./AttendenceFilter";
import { useState } from "react";
import { useSelector } from "react-redux";
import { FormInput, FormSelect } from "components/form/FormProvide";
import { Checkbox } from "antd/lib";

const tagRender = (props) => {
  const { label, onClose } = props;
  // const currentCompany = useSelector((state) => state.company.currentCompany);
  const onPreventMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      onMouseDown={onPreventMouseDown}
      closable={false}
      onClose={onClose}
      style={{
        border: "1px solid var(--font, #2BA4DD)",
        borderRadius: "59px",
        marginRight: 3,
        color: "var(--font, #2BA4DD)",
        display: "flex",
        alignItems: "center",
        padding: "4px 8px",
      }}
    >
      {label}
      <CloseOutlined style={{ marginLeft: 4 }} onClick={onClose} />
    </Tag>
  );
};

const WorkingLocation = ({
  isLoading = false,
  pagination = {},
  workingLocationList = [],
  currentWorkingLocation = {},
  initialValues = {},
  isModalOpen = false,
  currentCompany = {},
  deviceTypeOptions = [],
  organizationUnderOptions = [],
  onEdit = () => { },
  onCreate = () => { },
  onDelete = () => { },
  onStatus = () => { },
  editWorkingLocation = () => { },
  createWoringLocation = () => { },
  onCancel = () => { },
  onChange = () => { },
  onSubmit = () => { },
  onSearch = () => { },
}) => {
  // const { t } = useTranslation();
  const [useFilter, setUseFilter] = useState(false);
  const { roles } = useSelector((state) => state.company);
  const { t, i18n } = useTranslation();

  return (
    <>
      <Modal
        title={
          currentWorkingLocation.workInLocationId
            ? t("common.edit")
            : t("common.create")
        }
        open={isModalOpen}
        onCancel={() => {
          const cancelBtn = document.getElementById(
            "workingLocation__cancalBtn"
          );
          if (cancelBtn) {
            cancelBtn.click();
          } else {
            onCancel();
          }
        }}
        footer={null}
        width={510}
        closable={false}
        maskClosable={false}
      >
        {/* <Space size={24}> */}
        <Formik
          enableReinitialize
          initialValues={{ ...INITIAL_VALUES, ...initialValues }}
          onSubmit={(values, { resetForm }) => {
            Modal.confirm({
              title: t("dialog.confirmation.header"),
              content:
                (<p>
                  {t("dialog.confirmation.message", {
                    action: initialValues?.workInLocationId ? t("common.edit") : t("common.create"),
                  })}
                </p>
                ),
              onOk: async () => {
                const modifiedValues = { ...values, companyId: currentCompany, departmentListId: values.departmentListId };
                if (initialValues?.workInLocationId) {
                  await editWorkingLocation(modifiedValues);
                } else {
                  await createWoringLocation(modifiedValues, resetForm);
                  // onSubmit(values);
                }
              },
              okText: t("common.confirm"),
              cancelText: t("common.cancel"),
            });
            // resetForm();
          }}
          validationSchema={schema}
        >
          {({ values = {}, setFieldValue, resetForm }) => {
            const { deviceTypeId = "" } = values;
            const foundDevice =
              (deviceTypeOptions.find((d) => d.value === deviceTypeId) || {})
                .nameEn || "";
            return (
              <Form>
                <Space
                  direction="vertical"
                  size={6}
                  style={{ width: "100%" }}
                >
                  <Divider />
                  <Row gutter={[0, 16]}>
                    <Col span={24}>
                      <Select
                        name="deviceTypeId"
                        placeholder={t('please-select-1')}
                        size="large"
                        label={
                          t("workin_location.label.device_type")
                        }
                        options={deviceTypeOptions}
                        disabled={
                          currentWorkingLocation.workInLocationId
                            ? true
                            : false
                        }
                        onChange={(val) => {
                          const device =
                            (
                              deviceTypeOptions.find(
                                (d) => d.value === val
                              ) || {}
                            ).nameEn || "";
                          setFieldValue("deviceType", device);
                        }}
                        required
                      />
                    </Col>
                    <Col span={24}>
                      <Input
                        name="workInLocationName"
                        placeholder={t("workin_location.label.name")}
                        size="large"
                        label={
                          t("workin_location.label.name")
                        }
                        required
                      />
                    </Col>
                    <Col span={24}>
                      <Select
                        name="departmentListId"
                        size="large"
                        label={
                          t("workin_location.label.department")
                        }
                        mode="multiple"
                        placeholder={t('please-select-1')}
                        tagRender={tagRender}
                        options={organizationUnderOptions}
                        required
                      />
                    </Col>

                    {foundDevice === DEVICE_TYPE.GPS ? (
                      <>
                        <Col span={24}>
                          <Input
                            name="locationCoordinates"
                            placeholder={t('workin_location.label.latitude-longitude')}
                            size="large"
                            label={
                              t("workin_location.label.lat_long")
                            }
                            required
                            onKeyDown={(e) => {

                              const allowedKeys = [
                                "Backspace",
                                "Delete",
                                "ArrowLeft",
                                "ArrowRight",
                                "Tab",
                              ];

                              if (
                                (e.ctrlKey || e.metaKey) &&
                                ["c", "v", "x", "a"].includes(e.key.toLowerCase())
                              ) {
                                return;
                              }

                              if (allowedKeys.includes(e.key)) {
                                return;
                              }

                              const regex = /^[0-9.,-]$/;
                              if (!regex.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onPaste={(e) => {
                              const paste = e.clipboardData.getData("text");
                              const cleaned = paste.replace(/[^0-9.,-]/g, "");
                              if (cleaned === paste) return;

                              e.preventDefault();
                              const input = e.target;
                              const { selectionStart, selectionEnd } = input;

                              input.setRangeText(cleaned, selectionStart, selectionEnd, "end");
                              const inputEvent = new Event("input", { bubbles: true });
                              input.dispatchEvent(inputEvent);
                            }}
                          />
                        </Col>
                        {/* <Col span={24}>
                          <Row span={12}>
                            <Col span={12}>
                              <p>{t("workin_location.label.radius")}</p>
                            </Col>
                            <Col span={12}>
                              <p
                                style={{ color: "blue", textAlign: "right" }}
                              >
                                {`${values.radius} ${t("unit.meters")}`}
                              </p>
                            </Col>
                          </Row>
                          <Row span={12}></Row>
                          <Slider
                            value={values.radius}
                            defaultValue={0}
                            max={3000}
                            tooltip={{
                              formatter: (value) => `${value} Meter`,
                            }}
                            styles={{
                              track: {
                                background: "#2ba4dd",
                              },
                            }}
                            onChange={(val) => {
                              setFieldValue("radius", val);
                            }}
                          />
                        </Col> */}
                        <Col span={24}>
                          <Input
                            name="radius"
                            placeholder={t('workin_location.label.radius')}
                            size="large"
                            label={
                              t("workin_location.label.radius")
                            }
                            required

                          />
                        </Col>
                      </>
                    ) : (
                      <></>
                    )}
                    {foundDevice === DEVICE_TYPE.Fingerprint ? (
                      <>
                        <Col span={24}>
                          <Input
                            name="deviceName"
                            placeholder={
                              t("workin_location.label.device_name")
                            }
                            size="large"
                            label={
                              t("workin_location.label.device_name")
                            }
                            required
                          />
                        </Col>
                        <Col span={24}>
                          <Input
                            name="serialNumber"
                            placeholder={
                              t("workin_location.label.serial_number")
                            }
                            size="large"
                            label={
                              t("workin_location.label.serial_number")
                            }
                            required
                          />
                        </Col>
                        <Col span={24}>
                          <Switch
                            name="enableTimeLock"
                            label={t(
                              "workin_location.label.enable_time_lock"
                            )}
                          />
                        </Col>
                        <Col span={24}>
                          <Switch
                            name="automaticAddEmployee"
                            label={t("workin_location.label.auto_employee")}
                          />
                        </Col>
                      </>
                    ) : (
                      <></>
                    )}
                    {foundDevice === DEVICE_TYPE.Beacon ? (
                      <>
                        <Col span={24}>
                          <Input
                            name="deviceName"
                            placeholder={
                              t("workin_location.label.device_name")
                            }
                            size="large"
                            label={
                              t("workin_location.label.device_name")
                            }
                            required
                          />
                        </Col>
                        <Col span={24}>
                          <Input
                            name="serialNumber"
                            placeholder={
                              t("workin_location.label.serial_number")
                            }
                            size="large"
                            label={
                              t("workin_location.label.serial_number")
                            }
                            required
                          />
                        </Col>
                      </>
                    ) : (
                      <></>
                    )}
                    {foundDevice === DEVICE_TYPE.Wifi ? (
                      <>
                        <Col span={24}>
                          <Input
                            name="deviceName"
                            placeholder={
                              t("workin_location.label.device_name")
                            }
                            size="large"
                            label={
                              t("workin_location.label.device_name")
                            }
                            required
                          />
                        </Col>
                        <Col span={24}>
                          <Input
                            name="deviceId"
                            placeholder={
                              t("workin_location.label.device_id")
                            }
                            size="large"
                            label={
                              t("workin_location.label.device_id")
                            }
                            required
                          />
                        </Col>
                      </>
                    ) : (
                      <></>
                    )}
                    <Col span={24}>
                      <Checkbox name="isOffsite"
                        checked={values?.isOffsite === 'Y'}
                        onChange={(e) => {
                          setFieldValue("isOffsite", e.target.checked ? 'Y' : 'N');
                          // setFieldValue("isAllPosition", e.target.checked ? 'N' : 'Y');
                          // setFieldValue("conditionByPosition", [])
                          // setFieldValue("conditionForAllPosition.leavePermissionTime", {})
                        }}
                      // disabled={type == 'view'}
                      >
                        ใช้ในคำขอนอกสถานที่
                      </Checkbox>
                    </Col>
                  </Row>
                  <dir style={{ height: 16 }} />
                  <Row justify="end">
                    <Space direction="horizontal" size={12}>
                      <Button
                        id="workingLocation__cancalBtn"
                        type="default"
                        onClick={() => {
                          Modal.confirm({
                            title: t("dialog.confirmation.header"),
                            content: (
                              <span>{t('are-you-sure-confirm-to-cancel')}</span>
                            ),
                            onOk() {
                              onCancel()
                              resetForm()
                            },
                            okText: t("common.confirm"),
                            cancelText: t("common.cancel"),
                          })
                        }}
                        style={{ height: "40px", borderRadius: "8px" }}
                      >
                        {t("common.cancel").toUpperCase()}
                      </Button>
                      <Button

                        htmlType="submit" style={{ height: "40px", backgroundColor: "var(--button-color)", color: "var(--button-text-color)", borderRadius: "8px" }}>
                        {t("common.submit").toUpperCase()}
                      </Button>
                    </Space>
                  </Row>
                </Space>
              </Form>
            );
          }}
        </Formik>
        {/* </Space> */}
      </Modal>
      <Space className={styles.container} size={24} direction="vertical">
        <Row justify="end">
          <Space direction="horizontal" size={12}>
            <Button type="default" onClick={() => setUseFilter(!useFilter)} style={{ padding: "8px 16px", height: "44px", borderRadius: "8px" }}>
              <Flex align="center" justify="center" gap={8}>
                <FilterIcon />
                <span style={{ color: "#667085" }}>{t('common.filter')}</span>
              </Flex>
            </Button>
            {
              roles.includes("CREATE_CONFIGURATION|ATTENDANCE_SETTING|WORK_IN_LOCATION") && <Button onClick={onCreate} style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }} type="primary">
                <Flex align="center" justify="center" gap={8}>
                  <CreateIcon />
                  <span>{t('common.create')}</span>
                </Flex>
              </Button>
            }

          </Space>
        </Row>
        {useFilter && (
          <Card style={{ border: "solid 1px #EAECF0" }}>
            <AttendenceFilter
              isLoading={isLoading}
              pagination={pagination}
              dataSource={workingLocationList}
              deviceTypeOptions={deviceTypeOptions}
              onEdit={onEdit}
              dataFlag={"workinType"}
              onCancel={onCancel}
              onChange={onChange}
              onSubmit={onSearch}
            />
          </Card>
        )}
        {/* <CardContainer width="100%" height="fit-content"> */}
        <WorkingLocationTable
          isLoading={isLoading}
          pagination={pagination}
          dataSource={workingLocationList}
          onEdit={onEdit}
          onDelete={onDelete}
          onChange={onChange}
          onStatus={onStatus}
        />
        {/* </CardContainer> */}
      </Space>
    </>
  );
};

export default WorkingLocation;
